import styled from 'styled-components';
import Colors from '../../constants/color';

export const styles = {
  select: {
    marginTop: 34,
    marginBottom: 10,
    color: Colors.grey1,
  },
};
export const Label: any = styled.label`
  font-size: 14px;
  font-family: 'Graphik-Bold';
  color: ${Colors.grey2};
  margin-bottom: 6px;
`;
